<div class="modal-header py-2 d-flex flex-nowrap justify-content-end">
  <tr-icon [icon]="icon.cancel" classes="close-btn" [size]="iconSize.large" (click)="cancel()"></tr-icon>
</div>

<div class="modal-body">
  <div class="d-flex mb-2">
    <h2 class="ml-2 mr-2 font-weight-bold"> {{partyTitle}}</h2>
    <div class="ml-2 mr-2 flex" *ngIf="party.size">
      <tr-icon [icon]="icon.userCount" classes="mr-1"></tr-icon> {{party.size}}
    </div>
  </div>
  <div class="d-flex mb-1">
    <div class="ml-2 mr-2 flex" *ngIf="party.phone">
      <tr-icon [icon]="icon.call" classes="mr-1"></tr-icon> {{party.phone}}
    </div>
    <div class="ml-2 mr-2 flex">
      <tr-icon [icon]="icon.recent" classes="mr-1"></tr-icon>
      {{party.time}} - {{party.endTime}}
    </div>
  </div>
  <div class="d-flex mb-1">
    <div class="ml-2 mr-2" *ngIf="user.resourceSettings.enabled && user.resourceSettings.showOnPages && (party.resources || []).length">
      <span class="bi bi-layers"></span> <tablesready-model-name-display [id]="party.resources" [models]="resources"></tablesready-model-name-display>
    </div>
    <div class="ml-2 mr-2">
      <span *ngIf="user.serviceSettings.enabled && user.serviceSettings.showOnPages && (party.services || []).length">
        <tablesready-model-name-display [id]="party.services" [models]="services"></tablesready-model-name-display>
      </span>
    </div>
  </div>
  <div class="d-flex mb-1" *ngIf="party.seated_time">
    <div class="ml-2 mr-2">Seated time {{msToTime(party.seated_time)}}</div>
    <div class="ml-2 mr-2" *ngIf="party.duration">
      End time {{msToTime(party.seated_time + party.duration)}}
    </div>
  </div>

  <div class="py-2 d-flex flex-nowrap justify-content-end">
    <span  [ngbTooltip]="isRestaurantOnFreePlan ? 'Not available on Free Plan' : null">
      <button
        (mousedown)="chatBtnFocus = true"
        (mouseup)="chatBtnFocus = false"
        class="btn btn-info-outline btn-icon mr-2"
        data-toggle="tooltip"
        data-placement="top"
        title="Chat"
        (click)="chatParty()"
        *ngIf="showActions.chat"
        [disabled]="!party.phone || isRestaurantOnFreePlan"
      >
        <tr-icon [icon]="icon.chat" [color]="chatBtnFocus ? color.white : color.blue"></tr-icon>
      </button>
    </span>
    <button class="btn btn-info btn-icon mr-2" data-toggle="tooltip" data-placement="top" title="Edit"
      *ngIf="showActions.edit" (click)="editParty()">
      <tr-icon [icon]="icon.edit" [white]="true"></tr-icon>
    </button>
    <button class="btn btn-danger btn-icon mr-2" data-toggle="tooltip" data-placement="top" title="Cancel"
      *ngIf="showActions.cancel" (click)="markCanceled()" analyticsCategory="reservations" analytics2on="click"
      analyticsAction="canceled reservation">
      <tr-icon [icon]="icon.cancel" [white]="true"></tr-icon>
    </button>
  </div>
</div>

<div class="modal-footer justify-content-start align-items-stretch">
  <button *ngIf="showCheckInButton(party)"
          type="button"
          class="btn btn-success"
          (click)="checkIn()"
          analyticsCategory="reservations"
          analytics2on="click"
          analyticsAction="checked-in reservation"
  >
    <span class="bi bi-play-fill white"></span> Check-In
  </button>

  <button
    *ngIf="showServeButton(party)"
    type="button"
    class="btn btn-success"
    (click)="serveParty()"
    analyticsCategory="reservations"
    analytics2on="click"
    analyticsAction="serve reservation"
  >Serve</button>

  <button
    *ngIf="showCompleteButton(party)"
    type="button"
    class="btn btn-success"
    (click)="completeParty()"
    analyticsCategory="reservations"
    analytics2on="click"
    analyticsAction="completed reservation"
  >Completed</button>

  <button type="button" class="btn btn-danger ml-auto" data-toggle="tooltip" data-placement="top" title="Cancel"
    (click)="cancel()">Cancel
  </button>
</div>
